const anime = require('animejs');
require('snapsvg');

if (!window.anime) {
    window.anime = anime;
}

export {eachSlider};

function eachSlider(sliderIndex, SliderElement) {
    const $slider = $(SliderElement);
    const vTablet = 1023.9;
    const mobile = 767.9;
    const defaultInterval = 34536 * 1000;
    const initWidth = window.innerWidth;
    let slickInstance = null;
    let tDots = $slider.data('tablet-dots');
    let tArrow = $slider.data('tablet-arrow');
    let tArrows = $slider.data('tablet-arrows');
    let tAutoplay = $slider.data('tablet-autoplay');
    let tInterval = $slider.data('tablet-interval');
    let tInfinite = $slider.data('tablet-infinite');
    let tCenterMode = $slider.data('tablet-center-mode');
    let tAdaptiveH = $slider.data('tablet-adaptive-height');
    let tSlidesToShow = $slider.data('tablet-slides-to-show');
    let tVariableWidth = $slider.data('tablet-variable-width');
    let tSlidesToScroll = $slider.data('tablet-slides-to-scroll');
    let mDots = $slider.data('mobile-dots');
    let mArrow = $slider.data('mobile-arrow');
    let mArrows = $slider.data('mobile-arrows');
    let mAutoplay = $slider.data('mobile-autoplay');
    let mInterval = $slider.data('mobile-interval');
    let mInfinite = $slider.data('mobile-infinite');
    let mCenterMode = $slider.data('mobile-center-mode');
    let mAdaptiveH = $slider.data('mobile-adaptive-height');
    let mSlidesToShow = $slider.data('mobile-slides-to-show');
    let mVariableWidth = $slider.data('mobile-variable-width');
    let mSlidesToScroll = $slider.data('mobile-slides-to-scroll');

    tDots = typeof tDots !== 'undefined' ? tDots : true;
    tArrows = typeof tArrows !== 'undefined' ? tArrows : true;
    tArrow = typeof tArrow !== 'undefined' ? tArrows : 'chevron';
    tAutoplay = typeof tAutoplay !== 'undefined' ? tAutoplay : true;
    tInterval = typeof tInterval !== 'undefined' ? tInterval : false;
    tInfinite = typeof tInfinite !== 'undefined' ? tInfinite : true;
    tAdaptiveH = typeof tAdaptiveH !== 'undefined' ? tAdaptiveH : true;
    tCenterMode = typeof tCenterMode !== 'undefined' ? tCenterMode : false;
    tSlidesToShow = typeof tSlidesToShow !== 'undefined' ? tSlidesToShow : 1;
    tSlidesToScroll = typeof tSlidesToScroll !== 'undefined' ? tSlidesToScroll : 1;
    tVariableWidth = typeof tVariableWidth !== 'undefined' ? tVariableWidth : false;
    mDots = typeof mDots !== 'undefined' ? mDots : true;
    mArrows = typeof mArrows !== 'undefined' ? mArrows : false;
    mArrow = typeof mArrow !== 'undefined' ? mArrows : 'chevron';
    mAutoplay = typeof mAutoplay !== 'undefined' ? mAutoplay : true;
    mInterval = typeof mInterval !== 'undefined' ? mInterval : false;
    mInfinite = typeof mInfinite !== 'undefined' ? mInfinite : true;
    mAdaptiveH = typeof mAdaptiveH !== 'undefined' ? mAdaptiveH : true;
    mCenterMode = typeof mCenterMode !== 'undefined' ? mCenterMode : false;
    mSlidesToShow = typeof mSlidesToShow !== 'undefined' ? mSlidesToShow : 1;
    mSlidesToScroll = typeof mSlidesToScroll !== 'undefined' ? mSlidesToScroll : 1;
    mVariableWidth = typeof mVariableWidth !== 'undefined' ? mVariableWidth : false;

    let animationPaused = false;
    let $circlesFill;
    let circleLength;
    let currentAnimation;
    let snapCircle;

    const options = {
        focusOnSelect: false,
        responsive: [
            {
                breakpoint: 1023.9,
                settings: {
                    dots: tDots,
                    arrows: tArrows,
                    autoplay: tAutoplay,
                    infinite: tInfinite,
                    centerMode: tCenterMode,
                    adaptiveHeight: tAdaptiveH,
                    slidesToShow: tSlidesToShow,
                    variableWidth: tVariableWidth,
                    slidesToScroll: tSlidesToScroll,
                    autoplaySpeed: tInterval ? tInterval * 1000 : (tAutoplay ? 8000 : defaultInterval),
                    prevArrow: tArrows ? generateArrow('left', 'prev', tArrow) : false,
                    nextArrow: tArrows ? generateArrow('right', 'next', tArrow) : false,
                },
            },
            {
                breakpoint: 767.9,
                settings: {
                    dots: mDots,
                    arrows: mArrows,
                    autoplay: mAutoplay,
                    infinite: mInfinite,
                    centerMode: mCenterMode,
                    adaptiveHeight: mAdaptiveH,
                    slidesToShow: mSlidesToShow,
                    variableWidth: mVariableWidth,
                    slidesToScroll: mSlidesToScroll,
                    autoplaySpeed: mInterval ? mInterval * 1000 : (mAutoplay ? 8000 : defaultInterval),
                    prevArrow: tArrows ? generateArrow('left', 'prev', mArrow) : false,
                    nextArrow: tArrows ? generateArrow('right', 'next', mArrow) : false,
                },
            },
        ],
    };

    $(window).on('resize', handleResize);

    function initSlider() {
        if (initWidth > vTablet) {
            return;
        }

        $slider
            .on('init', (ev, slick) => {
                slickInstance = slick;

                if (slick.options.dots && slick.$dots) {
                    slick.$dots.find('button').each((i, btn) => {
                        $(btn)
                            .html(`<span class="slick-dot__index">${btn.textContent}</span>`)
                            .append(getDot());
                    });

                    $circlesFill = slick.$dots.find('.circle-progress__fill');
                    snapCircle = new Snap($circlesFill.get(0));
                    circleLength = snapCircle.getTotalLength() || 2 * Math.PI * snapCircle.getBBox().r1;
                    snapCircle.attr({
                        strokeDasharray: circleLength,
                        strokeDashoffset: circleLength,
                    });

                    animateDotCircleProgress(slick);
                }

                $(window).on('scroll', manageAnimationOnScroll);
                $slider.css('visibility', 'visible');
                NLMK.adaptiveBackgrounds($('.slick-active .js-adaptive-bg'));

                if (window.initLozad) {
                    window.initLozad();
                }
            })
            .on('beforeChange', () => {
                if (snapCircle) {
                    snapCircle.attr({
                        strokeDashoffset: circleLength,
                    });
                }
            })
            .on('afterChange', (ev, slick) => {
                if (slick.$dots) {
                    animateDotCircleProgress(slick);
                }

                NLMK.adaptiveBackgrounds($('.slick-active .js-adaptive-bg'));
            })
            .slick(options);
    }

    initSlider();

    function animateDotCircleProgress(slick) {
        if (typeof currentAnimation !== 'undefined') {
            currentAnimation.pause();
        }

        const $circleFill = slick.$dots.find('.slick-active').find('.circle-progress__fill');
        const CircleFill = $circleFill[0];
        let animation = $circleFill.data('animation');

        if (typeof animation === 'undefined') {
            animation = anime({
                targets: CircleFill,
                strokeDashoffset: [anime.setDashoffset, 2],
                duration: slick.options.autoplaySpeed,
                easing: 'linear',
                loop: false,
            });

            $circleFill.data({animation});
        } else {
            animation.restart();
        }

        currentAnimation = animation;
    }

    function manageAnimationOnScroll() {
        setTimeout(function () {
            if (isInViewport($slider)) {
                if (slickInstance && currentAnimation && animationPaused) {
                    animationPaused = false;
                    slickInstance.slickPlay();
                    currentAnimation.restart();
                }
            } else {
                if (slickInstance && currentAnimation && !animationPaused) {
                    animationPaused = true;
                    slickInstance.slickPause();
                }
            }
        }, 500);
    }

    function isInViewport($el) {
        const top = $el.offset().top;
        const height = parseInt($el.css('height'));

        return top < (window.pageYOffset + window.innerHeight) &&
            (top >= window.pageYOffset || (top + height) >= window.pageYOffset);
    }

    function handleResize() {
        const width = window.innerWidth;

        if (
            (initWidth <= mobile && width > mobile) ||
            (initWidth <= vTablet && initWidth > mobile && (width > vTablet || width <= mobile)) ||
            (initWidth > vTablet && width <= vTablet)
        ) {
            setTimeout(() => {
                location.reload();
            }, 0);
        }
    }
}

function generateArrow(direction, slickDirection, arrow) {
    return `<button type="button" class="slick-${slickDirection} js-hover">
                <svg class="svg-symbol svg-symbol--${arrow} svg-symbol--${arrow}-${direction}">
                    <use xlink:href="#svg-symbol--${arrow}-${direction}"/>
                </svg>
            </button>`;
}

function getDot() {
    return `<div>
                <svg class="circle-progress" width="30" height="30" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg">
                    <g fill="none">
                        <circle class="circle-progress__axis" cx="22" cy="22" r="20" stroke="#2c569780"/>
                        <circle class="circle-progress__fill" cx="22" cy="22" r="20" stroke="#2c5697" stroke-linecap="round" stroke-width="2"/>
                    </g>
                </svg>
            </div>`;
}



// WEBPACK FOOTER //
// ./js/main/module/sliders/vTabletMobile/module.js